export default "__VITE_ASSET__DZg9fnMg__"